// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20qUK","content":"styles_content__3d0we","tableWrap":"styles_tableWrap__2qWKO"};